import script from "./IDETabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDETabs.vue?vue&type=script&lang=ts&setup=true"

import "./IDETabs.vue?vue&type=style&index=0&id=0d97334b&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d97334b"]])

export default __exports__